import { Box, Theme } from '@mui/material';
import styled from 'styled-components';

import {
  TSelectedItemContainerProps,
  TSelectedItemVariant,
} from '@/shared/components/ui/selected-items-list/components/selected-item/selected-item.types';

const getVariantStyles = (theme: Theme, variant?: TSelectedItemVariant) => {
  switch (variant) {
    case 'secondary':
      return {
        background: theme.palette.background.paper,
        border: `1px solid ${theme.palette.primary.light}`,
      };
    case 'error':
      return {
        background: theme.palette.status.red.background,
        border: `1px solid ${theme.palette.status.red.stroke}`,
      };
    case 'warning':
      return {
        background: theme.palette.status.yellow.background,
        border: `1px solid ${theme.palette.status.yellow.stroke}`,
      };
    default:
      return {
        background: theme.palette.background.default,
        border: `1px solid ${theme.palette.divider}`,
      };
  }
};

export const SelectedItemContainer = styled(Box)<TSelectedItemContainerProps>`
  && {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    gap: 1rem;
    border-radius: ${({ theme }) => theme.shape.containerRadius};
    height: ${({ $sizeVariant }) =>
      $sizeVariant === 'compact' ? 2.5 : 3.25}rem;
    padding: ${({ $sizeVariant }) =>
      $sizeVariant === 'compact' ? '0 0.5rem 0 0.5rem' : '0 0.5rem 0 1rem'};

    ${({ theme, $variant }) => getVariantStyles(theme as Theme, $variant)}

    & > div > svg {
      width: 1.25rem;
      height: 1.25rem;
      color: ${({ theme }) => theme.palette.primary.main};
    }

    button {
      svg {
        color: ${({ theme }) => theme.palette.secondary.main};
        transition: color 0.2s ease-in-out;
      }

      &:hover {
        box-shadow: inset 0 0 0 1px ${({ theme }) => theme.palette.divider};
        transition: box-shadow 0.2s ease-in-out;

        svg {
          color: ${({ theme }) => theme.palette.secondary.dark};
        }
      }

      &.active-icon-button {
        svg {
          color: ${({ theme }) => theme.palette.primary.main};
        }

        &:hover {
          svg {
            color: ${({ theme }) => theme.palette.primary.dark};
          }
        }
      }
    }
  }
`;
